module.exports = __webpack_public_path__ + "static/avMaraExample-8b06e9923d882e33c1b7ea2fd60d01ae.jpg";